import { fetch, post } from "./base";

export const fetchVidboardAvatars = async (cache = true) => {
  return fetch("/avatarurl/", { cache });
};
export const fetchVidboarOnlydAvatars = async (cache = true) => {
  return fetch("/onlyavatarurl/", { cache });
};

export const fetchUserAvatar = async (userId, cache = true) => {
  return fetch("/userAvatarImage?userId=" + userId, {
    cache: false,
  });
};

export const fetchDidAvatars = async (cache = false) => {
  return fetch("/d-id/get-avatars", {
    cache,
  });
};
export const fetchDidOnlyAvatars = async (cache = false) => {
  return fetch("/d-id/get-onlyavatars/", {
    cache,
  });
};

export const saveGenerateAvatar = async (userId, avatar) => {
  return post("userAvatarImageSave/", {
    user_id: userId,
    avatar_image: avatar,
  });
};

export const createAvatarVideo = async (data) => {
  return post("d-id/create-avatar-video/", data);
};
